import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import Button from "@template/components/Button";
import { getDefaultStoreUrl } from "@template/state/modules/regionalStore";
import styles from "../NewsletterSignupForm.deferred.css";

const NewsletterForm = ({
  email,
  onEmailChange,
  onSubmit,
  onFocus,
  hasError,
  errorMessageKey,
  emailInputRef,
  formatTranslation
}) => {
  const defaultStoreUrl = useSelector(getDefaultStoreUrl);

  const termsHtml = formatTranslation("footer_newsletter_subscribe_terms", {
    privacypolicylink: `<a class="${styles.termsLink}" href="${defaultStoreUrl}privacy-policy/">${formatTranslation("footer_newsletter_subscribe_privacy_policy_link_text")}</a>`,
    termslink: `<a class="${styles.termsLink}" href="${defaultStoreUrl}terms-and-conditions/">${formatTranslation("footer_newsletter_subscribe_terms_link_text")}</a>`
  });

  return (
    <>
      <form
        className={styles.form}
        onSubmit={onSubmit}
        noValidate
        aria-labelledby="newsletter-form-title"
      >
        <div className={styles.inputWrapper}>
          <label htmlFor="newsletter-email" className={styles.label}>
            {formatTranslation("footer_newsletter_email_placeholder")}
          </label>
          <input
            id="newsletter-email"
            data-testid="newsletter-email-input"
            className={styles.input}
            type="email"
            required
            placeholder={formatTranslation(
              "footer_newsletter_email_placeholder"
            )}
            value={email}
            onChange={onEmailChange}
            onFocus={onFocus}
            ref={emailInputRef}
            aria-describedby={hasError ? "newsletter-error-message" : undefined}
          />
          {hasError && (
            <div
              role="alert"
              id="newsletter-error-message"
              data-testid="newsletter-error-message"
              className={styles.errorMessage}
            >
              {formatTranslation(errorMessageKey)}
            </div>
          )}
        </div>
        <div className={styles.submitButtonContainer}>
          <Button
            type="submit"
            data-testid="newsletter-submit-button"
            theme="primary"
            classes={styles.submitButton}
          >
            {formatTranslation("footer_newsletter_subscribe_cta")}
          </Button>
        </div>
      </form>
      <p
        className={styles.terms}
        data-testid="newsletter-terms"
        dangerouslySetInnerHTML={{ __html: termsHtml }}
      />
    </>
  );
};

NewsletterForm.propTypes = {
  email: PropTypes.string.isRequired,
  onEmailChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  errorMessageKey: PropTypes.string.isRequired,
  emailInputRef: PropTypes.shape({ current: PropTypes.any }).isRequired,
  formatTranslation: PropTypes.func.isRequired
};

export default NewsletterForm;
